import { watch } from 'vue'

const PRESET_DAYS = {
    today: 1,
    past30: 30,
    past90: 90,
}

function normalizeTag(selectedTag) {
    return Array.isArray(selectedTag) ? JSON.stringify(selectedTag) : selectedTag || ''
}

function normalizeDate(value) {
    return value || ''
}

export function viewResultsQuery(props) {
    return {
        orgId: props.org.orgId,
        viewId: props.view.viewId,
        componentIndex: props.componentIndex,
        selectedTag: props.selectedTag,
        startDate: props.startDate,
        endDate: props.endDate,
    }
}

export function orgViewResultsCacheKey({
    orgId,
    viewId,
    componentIndex,
    selectedTag,
    startDate,
    endDate,
}) {
    return `ovr:${orgId}:${viewId}:${componentIndex}:${normalizeTag(selectedTag)}:${normalizeDate(startDate)}:${normalizeDate(endDate)}`
}

export function staffViewResultsCacheKey({
    orgId,
    viewId,
    componentIndex,
    selectedTag,
    startDate,
    endDate,
}) {
    return `svr:${orgId}:${viewId ?? ''}:${componentIndex ?? ''}:${normalizeTag(selectedTag)}:${normalizeDate(startDate)}:${normalizeDate(endDate)}`
}

export function pulseFactorInsightsCacheKey({
    orgId,
    viewId,
    componentIndex,
    selectedTag,
    startDate,
    endDate,
    factorType,
    factorValue,
}) {
    return `pfi:${orgId}:${viewId}:${componentIndex}:${normalizeTag(selectedTag)}:${normalizeDate(startDate)}:${normalizeDate(endDate)}:${factorType}:${factorValue}`
}

// A preset that matches the widget's YAML fromDays is the same window as the
// first load (no dates sent). Omit dates so both share a client cache entry.
export function apiDatesForComponent({ startDate, endDate, preset, fromDays } = {}) {
    const days = Number(fromDays) || 90
    if (PRESET_DAYS[preset] === days) {
        return { startDate: '', endDate: '' }
    }
    return { startDate: startDate || '', endDate: endDate || '' }
}

export function watchDashboardFilters(props, onChange, { includeTag = true } = {}) {
    const sources = includeTag
        ? [() => normalizeTag(props.selectedTag), () => props.startDate || '', () => props.endDate || '']
        : [() => props.startDate || '', () => props.endDate || '']
    return watch(sources, (next, prev) => {
        if (Array.isArray(prev) && next.every((value, i) => value === prev[i])) return
        onChange()
    })
}
